// Turn a free-form URL (as typed into the admin's "Social links" list) into
// a display descriptor: the brand icon for known networks, a plain globe for
// everything else.
const NETWORKS = [
  {
    test: /(^|\.)facebook\.com|(^|\.)fb\.com|fb\.me/,
    icon: 'fab fa-facebook-f',
    label: 'Facebook',
    color: '#1877f2'
  },
  {
    test: /(^|\.)instagram\.com/,
    icon: 'fab fa-instagram',
    label: 'Instagram',
    color: '#e4405f'
  },
  {
    test: /(^|\.)linkedin\.com/,
    icon: 'fab fa-linkedin-in',
    label: 'LinkedIn',
    color: '#0a66c2'
  },
  {
    test: /(^|\.)youtube\.com|youtu\.be/,
    icon: 'fab fa-youtube',
    label: 'YouTube',
    color: '#ff0000'
  },
  {
    test: /(^|\.)twitter\.com|(^|\.)x\.com/,
    icon: 'fab fa-twitter',
    label: 'X / Twitter',
    color: '#111827'
  },
  {
    test: /(^|\.)tiktok\.com/,
    icon: 'fab fa-tiktok',
    label: 'TikTok',
    color: '#111827'
  },
  {
    test: /(^|\.)snapchat\.com/,
    icon: 'fab fa-snapchat-ghost',
    label: 'Snapchat',
    color: '#f5c400'
  },
  {
    test: /(^|\.)pinterest\./,
    icon: 'fab fa-pinterest-p',
    label: 'Pinterest',
    color: '#e60023'
  },
  {
    test: /(^|\.)vimeo\.com/,
    icon: 'fab fa-vimeo-v',
    label: 'Vimeo',
    color: '#1ab7ea'
  },
  {
    test: /(^|\.)(wa\.me|whatsapp\.com)/,
    icon: 'fab fa-whatsapp',
    label: 'WhatsApp',
    color: '#25d366'
  },
  {
    test: /(^|\.)(t\.me|telegram\.)/,
    icon: 'fab fa-telegram-plane',
    label: 'Telegram',
    color: '#229ed9'
  },
  {
    test: /(^|\.)github\.com/,
    icon: 'fab fa-github',
    label: 'GitHub',
    color: '#111827'
  }
];

export function normalizeLinkUrl(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return '';
  if (/^(https?:|mailto:|tel:)/i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function socialLinkMeta(rawUrl) {
  const href = normalizeLinkUrl(rawUrl);
  let host = '';
  try {
    host = new URL(href).hostname.toLowerCase();
  } catch (e) {
    host = String(rawUrl || '').toLowerCase();
  }
  const net = NETWORKS.find((n) => n.test.test(host));
  if (net)
    return {
      href,
      icon: net.icon,
      label: net.label,
      color: net.color,
      brand: true
    };
  return {
    href,
    icon: 'fas fa-globe',
    label: host.replace(/^www\./, '') || 'Website',
    color: '',
    brand: false
  };
}
